<div class="content-spinner-container"
     [style.width]="sizeValue"
     [style.height]="sizeValue"
>
    <!--
        First Loader: Primary (base) → Secondary (animated fill)
        Visible during first half of animation cycle (0-50%)
        Becomes invisible when secondary fill completes
    -->
    <div class="content-spinner-loader content-spinner-loader-first"
         [style.animation-duration]="animationDuration"
    >
        <!-- Base circle with primary color -->
        <div class="content-spinner-base"
             [style.border-color]="primaryColor"
             [style.border-width]="borderWidthInPixels"
        >
        </div>

        <!-- Animated overlay with secondary color filling clockwise -->
        <div class="content-spinner-overlay"
             [style.border-color]="secondaryColor"
             [style.border-width]="borderWidthInPixels"
             [style.animation-duration]="loaderDuration"
        >
        </div>
    </div>

    <!--
        Second Loader: Secondary (base) → Tertiary (animated fill)
        Visible during second half of animation cycle (50-100%)
        Becomes invisible when tertiary fill completes
    -->
    <div class="content-spinner-loader content-spinner-loader-second"
         [style.animation-duration]="animationDuration"
    >
        <!-- Base circle with secondary color -->
        <div class="content-spinner-base"
             [style.border-color]="secondaryColor"
             [style.border-width]="borderWidthInPixels"
        >
        </div>

        <!-- Animated overlay with tertiary color filling clockwise -->
        <div class="content-spinner-overlay"
             [style.border-color]="tertiaryColor"
             [style.border-width]="borderWidthInPixels"
             [style.animation-duration]="loaderDuration"
        >
        </div>
    </div>
</div>
